import React from 'react'
import { Text, Container, Heading } from '@chakra-ui/react'

import { SectorDataSelect } from 'modules/sector'
import { FormField, FieldList, FieldListItem, RadioGroupBoolean, WizardStepForm } from 'components'

export const UserRegistrationStep3 = props => (
  <WizardStepForm {...props} justify='center'>
    <Heading size='2xl' textAlign='center' my={5}>
      Dados da Entidade
    </Heading>
    <Container my={5}>
      <Text textAlign='end'  color='red.500'>* Resposta obrigatória</Text>
      <FieldList my={3} variant='vertical'>
        <FieldListItem isRequired label='Setor'>
          <FormField name='entity.sector[].id'>
            <SectorDataSelect isMultiple />
          </FormField>
        </FieldListItem>

        <FieldListItem isRequired label='O registo é feito em nome da entidade?'>
          <FormField name='entity.onEntityBehalf'>
            <RadioGroupBoolean />
          </FormField>
        </FieldListItem>

        {/*
        @TODO 
        <FieldListItem label='Documento de acreditação da entidade (pdf)'>
          <FormField name='entity.document'>
            <Input type='file' />
          </FormField>
        </FieldListItem>
        */}
      </FieldList>
    </Container>
  </WizardStepForm>
)

export default UserRegistrationStep3
